import React, { useEffect, useState } from "react";
import { apiCall_domain, token } from "../api";
import axios from "axios";
import Header from "../header";
import Spinner from "../Spinner/Spinner";

function RulesAndConditions(props) {
  const [loading, setLoading] = useState(true);
  const [rulesDetails, setRulesDetails] = useState(null);

  useEffect(() => {
    const Headers = {
      Authorization: token(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/options?want=POLICY`, {
        headers: Headers,
      })
      .then((res) => {
        setLoading(false);
        setRulesDetails(res.data.data);
      });
  });

  const handleAccept = () => {
    props.history.push({
      pathname: "/",
      accept: true,
    });
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Header showSearchBar={true} title={"شرایط و قوانین"} />
          <div className="rulesMainDiv">
            <div className="rulesComponent">{rulesDetails}</div>
            <div className="acceptRules">
              <button onClick={handleAccept}>قوانین و شرایط را می پذیرم</button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default RulesAndConditions;
